import axios from "./configAxios";

export const getPermissionListApi = async() => {
    return await axios.get('/list/')
}